import React, {Component} from 'react';

import {ClientAppContentContent} from "./ClientAppContentContent";
import {withRouterParams} from "../../utils/withRouterParams";

class ClientAppContent extends Component {
    render() {
        return (
            <ClientAppContentContent clientId={this.props.match.params.client_id}
                                     appHash={this.props.match.params.app_hash}/>
        )
    }
}

export default withRouterParams(ClientAppContent);

